module.exports = "/_next/static/images/c5f4a74bfc73148ae166b1863572f375-mulher-com-cachos-maravilhosos-segurando-cartao-xs@1x.jpg.webp";